const getLanguage = () => {
  const languageMap = {
    nb: ["nn", "nb", "no", "nn-NO", "nb-NO", "nb-SJ", "se", "se-NO"],
    en: ["en", "en-GB", "en-US", "en-CA"],
    de: ["de", "de-AT", "de-CH", "de-DE", "de-LI", "de-LU"],
    ro: ["ro", "ro-RO"],
    sv: ["sv", "sv-FI", "sv-SE"],
    da: ["da"],
    fr: ["fr", "fr-BE", "fr-CA", "fr-CH", "fr-FR"],
    th: ["th"],
  };

  let language = localStorage.getItem("language") || navigator.language;

  for (const [key, values] of Object.entries(languageMap)) {
    if (values.includes(language)) {
      return key;
    }
  }

  return "en"; // Default language
};

export default getLanguage;
